import { call, options, params } from './helpers';

export const getAllPowerusers = (payload) =>
	call(`/beta/watchlist${params(payload)}`);

export const getAllAssetPowerusers = (payload) =>
	call(`/beta/watchlist${params(payload)}`);

export const addToWatchlist = (payload) =>
	call(`/beta/watchlist`, options(payload, 'POST'));

export const removeFromWatchlist = (id) =>
	call(`/beta/watchlist/${id}`, options(null, 'DELETE'));
